import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isNCProMenuOpen: false,
  isReportsMenuOpen: false,
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setNCProMenuOpen: (state, action) => {
      state.isNCProMenuOpen = action.payload;
    },
    setReportsMenuOpen: (state, action) => {
      state.isReportsMenuOpen = action.payload;
    },
  },
});

export const { setNCProMenuOpen, setReportsMenuOpen } = menuSlice.actions;
export default menuSlice.reducer;
